import bem from 'utils/bem';

export const block = bem('cancellation-reason-modal');
